import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import { exposeTestId } from '../../config';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { RadioListState } from '../../store/birdElement/radioListState';
import { selectBirdRadioListState, selectStyleState, selectAccessibilityLabelState, } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { fontStyles, textHeight, longestTextWidth } from '../utils/style';
import { useFontLoadedKey } from '../FontProvider';
import { SearchableList } from '../SearchableList';
import { useListItemHeightCache } from '../SearchableList/useListItemHeightCache';
const radioListItemWidthPadding = 40 /*radio button column*/ + 8 + 26 /*padding*/ + 2; /*border*/
export const BirdRadioListBase = function (props) {
    const actions = props.actions;
    const { values, measureValues, selectedIndex, searchable, searchValue } = props.state;
    const { font } = props.style || {};
    let itemHeight;
    const [measurements, setMeasurements] = useState();
    {
        const dt = useDesignTokens();
        const fonts = useMemo(() => fontStyles(font, dt), [font, dt]);
        const uiFonts = useMemo(() => fontStyles(undefined, dt), [dt]);
        const fontKey = useFontLoadedKey(fonts.fontFamily);
        const preferredValues = props.preferredSizing ? values : undefined;
        const preferredMeasureValues = props.preferredSizing ? measureValues : undefined;
        const { itemHeight: _itemHeight, refCache } = useListItemHeightCache(values, fonts, fontKey);
        itemHeight = _itemHeight;
        useLayoutEffect(() => {
            const heightCache = refCache.current; // guaranteed to be defined
            const searchHeight = searchable
                ? Math.max(28, textHeight(uiFonts) + 4 /* padding */) +
                    1 /* input fudge factor */ +
                    2 /* border */ +
                    6 /* padding around */
                : 0;
            const constraints = {
                minHeight: heightCache.getBaseItemHeight() * 2 + searchHeight,
                minWidth: 160,
            };
            if (preferredValues) {
                constraints.preferredWidth =
                    radioListItemWidthPadding +
                        longestTextWidth(preferredValues, fonts) +
                        (preferredMeasureValues
                            ? 8 /* text gap */ +
                                Math.max(24 /* min-width */, longestTextWidth(preferredMeasureValues, fonts))
                            : 0);
                constraints.preferredHeight = heightCache.getTotalHeight() + searchHeight;
            }
            setMeasurements({
                preferredWidth: constraints.preferredWidth,
                preferredHeight: constraints.preferredHeight,
            });
            actions.setConstraints(props.id, constraints);
        }, [
            fontKey /*(implicit)*/,
            actions,
            preferredValues,
            preferredMeasureValues,
            props.id,
            fonts,
            uiFonts,
            searchable,
            refCache,
        ]);
    }
    return (_jsx(SearchableList, { type: "single", searchable: searchable, selection: [selectedIndex || 0], onSelect: (selectedIndices) => {
            actions.update(props.id, { selectedIndex: selectedIndices[0] });
        }, values: values, measureValues: measureValues, listTestId: exposeTestId() ? `${props.id}-RdList` : null, accessibilityLabel: props.accessibilityLabel, styleState: props.style, itemHeight: itemHeight, preferredWidth: measurements === null || measurements === void 0 ? void 0 : measurements.preferredWidth, preferredHeight: measurements === null || measurements === void 0 ? void 0 : measurements.preferredHeight, searchValue: searchValue !== null && searchValue !== void 0 ? searchValue : '', onSearchValueChange: (value) => actions.update(props.id, { searchValue: value }) }));
};
export const BirdRadioList = connect((state, props) => ({
    state: selectBirdRadioListState(state, props.id),
    style: selectStyleState(state, props.id),
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, RadioListState.actions), dispatch),
}))(BirdRadioListBase);
